// extracted by mini-css-extract-plugin
module.exports =  {"close":"_93444fe79c--close--m8UBG"};